import React from 'react';
import {
  Box,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Slider,
  Stack,
  Button,
} from '@mui/material';
import { ExpandMore, FilterList, Clear } from '@mui/icons-material';

const UniversityFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  filterOptions,
  activeFiltersCount = 0
}) => {
  const handleFilterChange = (filterType, value) => {
    onFilterChange(filterType, value);
  };

  const handleTuitionRangeChange = (event, newValue) => {
    onFilterChange('tuitionRange', newValue);
  };

  const hasActiveFilters = activeFiltersCount > 0;

  return (
    <Paper elevation={1} sx={{ mb: 3 }}>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{
            backgroundColor: 'grey.50',
            '&:hover': { backgroundColor: 'grey.100' }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <FilterList sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              筛选条件
            </Typography>
            {hasActiveFilters && (
              <Chip 
                label={`${activeFiltersCount}个筛选`} 
                size="small" 
                color="primary" 
                sx={{ mr: 2 }}
              />
            )}
            {hasActiveFilters && (
              <Button
                size="small"
                startIcon={<Clear />}
                onClick={(e) => {
                  e.stopPropagation();
                  onClearFilters();
                }}
                sx={{ minWidth: 'auto' }}
              >
                清除
              </Button>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            {/* 地区筛选 */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>地区</InputLabel>
                <Select
                  value={filters.location || ''}
                  label="地区"
                  onChange={(e) => handleFilterChange('location', e.target.value)}
                >
                  <MenuItem value="">全部地区</MenuItem>
                  {filterOptions.locations.map((location) => (
                    <MenuItem key={location} value={location}>
                      {location}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 大学类型筛选 */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>类型</InputLabel>
                <Select
                  value={filters.type || ''}
                  label="类型"
                  onChange={(e) => handleFilterChange('type', e.target.value)}
                >
                  <MenuItem value="">全部类型</MenuItem>
                  {filterOptions.types.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 排名筛选 */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>QS排名</InputLabel>
                <Select
                  value={filters.ranking || ''}
                  label="QS排名"
                  onChange={(e) => handleFilterChange('ranking', e.target.value)}
                >
                  <MenuItem value="">全部排名</MenuItem>
                  <MenuItem value="50">前50名</MenuItem>
                  <MenuItem value="100">前100名</MenuItem>
                  <MenuItem value="200">前200名</MenuItem>
                  <MenuItem value="500">前500名</MenuItem>
                  <MenuItem value="1000">前1000名</MenuItem>
                  <MenuItem value="2000">前2000名</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* 排序方式 */}
            {/* <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>排序</InputLabel>
                <Select
                  value={filters.sortBy || 'ranking'}
                  label="排序"
                  onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                >
                  <MenuItem value="ranking">按排名由高到低</MenuItem>
                  <MenuItem value="tuition-low">学费由低到高</MenuItem>
                  <MenuItem value="tuition-high">学费由高到低</MenuItem>
                  <MenuItem value="students-high">学生人数由多到少</MenuItem>
                  <MenuItem value="students-low">学生人数由少到多</MenuItem>
                  <MenuItem value="established-high">成立年份由近到远</MenuItem>
                  <MenuItem value="established-low">成立年份由远到近</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}

            {/* 学费范围筛选 */}
            <Grid item xs={12} md={6}>
              <Typography gutterBottom variant="body2" color="text.secondary">
                学费范围 (RM/年)
              </Typography>
              <Box sx={{ px: 2 }}>
                <Slider
                  value={filters.tuitionRange || [10000, 100000]}
                  onChange={handleTuitionRangeChange}
                  valueLabelDisplay="auto"
                  min={0}
                  max={1000000}
                  step={5000}
                  valueLabelFormat={(value) => `RM ${typeof value === 'number' ? value.toLocaleString() : value || '0'}`}
                  marks={[
                    { value: 0, label: 'RM 0' },
                    { value: 500000, label: 'RM 500K' },
                    { value: 1000000, label: 'RM 1000K' },
                  ]}
                />
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default UniversityFilters;